<template>
    {{ timeFormatted }}
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref, watch } from 'vue'

const emits = defineEmits<{
    'time:end': []
    'time:update': [number]
}>()

const props = defineProps<{
    seconds: number
}>()

const timeRemains = ref(props.seconds)
const timeFormatted = computed(() => formatTime(timeRemains.value))
const timerId = ref<number>()

watch(timeRemains, (value) => {
    if (value <= 0) {
        destroy()
        emits('time:end')
    }
})

watch(
    () => props.seconds,
    () => {
        restart()
    }
)

onMounted(restart)
onUnmounted(destroy)
defineExpose({
    destroy,
    restart,
})

function destroy() {
    clearInterval(timerId.value)
}

function formatTime(value: number) {
    let minutes: number | string = Math.floor(value / 60)
    let seconds: number | string = value - minutes * 60

    if (minutes.toString().length === 1) {
        minutes = `0${minutes}`
    }

    if (seconds.toString().length === 1) {
        seconds = `0${seconds}`
    }

    return `${minutes}:${seconds}`
}

function restart() {
    destroy()
    timeRemains.value = props.seconds
    timerId.value = window.setInterval(() => {
        --timeRemains.value
        emits('time:update', timeRemains.value)
    }, 1000)
}
</script>

<style src="./VTimer.scss" lang="scss" />
